import { RequestFactory } from "@/requests/RequestFactory";
const prestacaoContaRequest = RequestFactory.get("prestacaoConta");

export default {
  namespaced: true,

  state: {
    isFetching: false,
    items: {}
  },

  mutations: {
    FETCHING_OFF(state) {
      state.isFetching = false;
    },
    FETCHING_ON(state) {
      state.isFetching = true;
    }    
  },

  actions: {
    requestOn({commit}) { commit('FETCHING_ON'); },
    requestOff({commit}) { commit('FETCHING_OFF'); },

    fetchAllPrestacaoConta: ({ dispatch }) => dispatch('fetchAllItems', { resource: 'prestacaoConta' }, { root: true }),

    fetchPrestacaoConta: ({ dispatch }, { prestacaoContaId }) => dispatch('fetchItem', { resource: 'prestacaoConta', prestacaoContaId }, { root: true }),

    fetchPrestacaoContaByProjeto: ({ dispatch }, projetoId) => {
      const payload = { resource: 'prestacaoConta', id: projetoId }
      return dispatch('fetchItemsParent', payload, { root: true })
    },

    fetchPrestacaoContaById({ commit, dispatch }, payload) {
      dispatch('requestOn');
      return prestacaoContaRequest.findById(payload.projetoId, payload.prestacaoContaId).then(response => {
        dispatch('requestOff');
        const payload = { resource: 'prestacaoConta', item: response.data }
        commit('setItem', payload, { root: true })
        return response.data
      })
    },    

    criarPrestacaoConta({ commit, dispatch }, payload) {
      dispatch('requestOn');
      return prestacaoContaRequest.post(payload.projetoId, payload.prestacaoConta, payload.file).then(response => {
        dispatch('requestOff');
        const payload = { resource: 'prestacaoConta', item: response.data }
        commit('setItem', payload, { root: true })

        const notification = {
          type: 'success',
          message: 'Prestação de Contas criada com sucesso.'
        }
        dispatch('notification/add', notification, { root: true })        

        return response.data
      })
    },

    editarPrestacaoConta({ commit, dispatch }, payload) {
      dispatch('requestOn');
      return prestacaoContaRequest.editar(payload.projetoId, payload.prestacaoConta, payload.file).then(response => {
        dispatch('requestOff');
        const payload = { resource: 'prestacaoConta', item: response.data }
        commit('setItem', payload, { root: true })

        const notification = {
          type: 'success',
          message: 'Prestação de Contas atualizada com sucesso.'
        }
        dispatch('notification/add', notification, { root: true })

        return response.data
      })
    },

    excluirPrestacaoConta({ commit, dispatch }, payload) {
      dispatch('requestOn');
      const projetoId = payload.projetoId;
      const prestacaoContaId = payload.prestacaoContaId;
      return prestacaoContaRequest.delete(projetoId, prestacaoContaId).then(() => {
        dispatch('requestOff');
        const payload = { resource: 'prestacaoConta', itemId: prestacaoContaId }
        commit('deleteItem', payload, { root: true })
        const notification = {
          type: 'success',
          message: 'Prestação de Contas removida com sucesso.'
        }
        return dispatch('notification/add', notification, { root: true })
      })
    },   

    criarMonitoramentoFinaceiro({ commit, dispatch }, payload) {
      dispatch('requestOn');
      return prestacaoContaRequest.postMonitoramentoFinaceiro(payload.projetoId, payload.prestacaoContaId, payload.monitoramentoFinanceiro, payload.file).then(response => {
        dispatch('requestOff');
        const payload = { resource: 'prestacaoConta', item: response.data }
        commit('setItem', payload, { root: true })

        const notification = {
          type: 'success',
          message: 'Monitoramento Financeiro criado com sucesso.'
        }
        dispatch('notification/add', notification, { root: true })        

        return response.data
      })
    },

    editarMonitoramentoFinaceiro({ commit, dispatch }, payload) {
      dispatch('requestOn');
      return prestacaoContaRequest.editarMonitoramentoFinaceiro(payload.projetoId, payload.prestacaoContaId, payload.monitoramentoFinanceiro, payload.file).then(response => {
        dispatch('requestOff');
        const payload = { resource: 'prestacaoConta', item: response.data }
        commit('setItem', payload, { root: true })

        const notification = {
          type: 'success',
          message: 'Monitoramento Financeiro atualizada com sucesso.'
        }
        dispatch('notification/add', notification, { root: true })

        return response.data
      })
    },

    realizarManifestacao({ commit, dispatch }, payload) {
      dispatch('requestOn');
      return prestacaoContaRequest.putManifestacao(payload.projetoId, payload.prestacaoContaId, payload.observacoes, payload.file).then(response => {
        dispatch('requestOff');
        const payload = { resource: 'prestacaoConta', item: response.data }
        commit('setItem', payload, { root: true })

        const notification = {
          type: 'success',
          message: 'Manifestação da OSC criada com sucesso.'
        }
        dispatch('notification/add', notification, { root: true })        

        return response.data
      })
    },

    realizarParecer({ commit, dispatch }, payload) {
      dispatch('requestOn');
      return prestacaoContaRequest.putParecer(payload.projetoId, payload.prestacaoContaId, payload.parecer, payload.observacoes, payload.file).then(response => {
        dispatch('requestOff');
        const payload = { resource: 'prestacaoConta', item: response.data }
        commit('setItem', payload, { root: true })

        const notification = {
          type: 'success',
          message: 'Parecer Comissão criado com sucesso.'
        }
        dispatch('notification/add', notification, { root: true })        

        return response.data
      })
    },    

    upload({commit, dispatch}, payload) {
      return prestacaoContaRequest.putArquivos(payload).then(response => {
        const payload = {resource: 'prestacaoConta', item: response.data}
        commit('setItem', payload, {root: true})

        const notification = {
          type: 'success',
          message: 'Arquivos adicionados com sucesso'
        }
        dispatch('notification/add', notification, { root: true })        

        return response.data
      })
    },

    downloadArquivo({dispatch}, payload) {
      dispatch('requestOn');
      return prestacaoContaRequest.downloadArquivo(payload).then(() => {
        dispatch('requestOff');        
      })
    },

    proximaEtapa({ commit, dispatch }, payload) {
      dispatch('requestOn');
      return prestacaoContaRequest.proximaEtapa(payload.projetoId, payload.prestacaoContaId, payload.enviarPara).then(response => {
        dispatch('requestOff');
        const payload = { resource: 'prestacaoConta', item: response.data }
        commit('setItem', payload, { root: true })

        const notification = {
          type: 'success',
          message: 'Processo de Prestação de Contas enviado com sucesso.'
        }
        dispatch('notification/add', notification, { root: true })        

        return response.data
      })
    },    

    reaberturaPrestacaoConta({ commit, dispatch }, payload) {
      dispatch('requestOn');
      return prestacaoContaRequest.proximaEtapa(payload.projetoId, payload.prestacaoContaId, payload.enviarPara).then(response => {
        dispatch('requestOff');
        const payload = { resource: 'prestacaoConta', item: response.data }
        commit('setItem', payload, { root: true })

        const notification = {
          type: 'success',
          message: 'Processo de Prestação de Contas Reaberto com  sucesso.'
        }
        dispatch('notification/add', notification, { root: true })        

        return response.data
      })
    },    

  },

  getters: {
    all: state => {
      return state.items ? Object.values(state.items) : []
    },    
    byId: (state) => prestacaoContaId => {
      if (state.items) {
        return Object.values(state.items)
          .find(prestacaoConta => prestacaoConta.id === prestacaoContaId)
      }
      return {}
    },
    arquivobyIdAndFase: (state) => (prestacaoContaId, fase) => {
      if (state.items) {
        var prestacaoConta = Object.values(state.items)
          .find(prestacaoConta => prestacaoConta.id === prestacaoContaId)

          if(fase === 'PRESTACAO') {
            return prestacaoConta.arquivoPrestacao
          }
          if(fase === 'MONITORAMENTO') {
            return prestacaoConta.arquivoMonitoramento
          }
          if(fase === 'MANIFESTACAO') {
            return prestacaoConta.arquivoManifestacao
          }
          if(fase === 'PARECER') {
            console.log(prestacaoConta.arquivoParecer)
            return prestacaoConta.arquivoParecer
          }
      }
      return null
    },

    hasPermission: (state) => payload => {
      const prestacaoConta = state.items[payload.prestacaoContaId];

      var permissions = [];

      switch (prestacaoConta.status) {
        case 'ABERTO':
          if(payload.papeis.includes('AGENTE_PRESTACAO_CONTA')) {
            permissions.push(
              "PERMISSION_PRESTACAO_CONTAS_EDIT", 
              "PERMISSION_PRESTACAO_CONTAS_VIEW"
            );
          }
          break;
        case 'AGUARDANDO_MONITORAMENTO':
          if(payload.papeis.includes('AGENTE_PRESTACAO_CONTA')) {
            permissions.push(
              'PERMISSION_PRESTACAO_CONTAS_VIEW'
            );
          }
          if(payload.papeis.includes('AGENTE_MONITORAMENTO_FINANCEIRO')) {
            permissions.push(
              'PERMISSION_MONITORAMENTO_FINANCEIRO_EDIT',
              'PERMISSION_PRESTACAO_CONTAS_VIEW',
              'PERMISSION_MONITORAMENTO_FINANCEIRO_VIEW',
              'PERMISSION_PRESTACAO_CONTAS_DELETE_ABERTURA',
            );
          }
          break;
        case 'AGUARDANDO_MANIFESTACAO':
          if(payload.papeis.includes('AGENTE_PRESTACAO_CONTA')) {
            permissions.push(
              'PERMISSION_MANIFESTACAO_EDIT',
              'PERMISSION_MANIFESTACAO_VIEW',
              'PERMISSION_PRESTACAO_CONTAS_VIEW',
              'PERMISSION_MONITORAMENTO_FINANCEIRO_VIEW',
            );
          }
          if(payload.papeis.includes('AGENTE_MONITORAMENTO_FINANCEIRO')) {
            permissions.push(
              'PERMISSION_PRESTACAO_CONTAS_VIEW',
              'PERMISSION_MONITORAMENTO_FINANCEIRO_VIEW',
            );
          }
          break;        
        case 'AGUARDANDO_PARECER':
          if(payload.papeis.includes('COMISSAO_PRESTACAO_CONTA')) {
            permissions.push(
              'PERMISSION_PARECER_EDIT',
              'PERMISSION_PARECER_VIEW',
              'PERMISSION_PRESTACAO_CONTAS_VIEW',
              'PERMISSION_MONITORAMENTO_FINANCEIRO_VIEW',
              'PERMISSION_MANIFESTACAO_VIEW',
            );
          }
          if(payload.papeis.includes('AGENTE_PRESTACAO_CONTA')) {
            permissions.push(
              'PERMISSION_PRESTACAO_CONTAS_VIEW',
              'PERMISSION_MONITORAMENTO_FINANCEIRO_VIEW',
              'PERMISSION_MANIFESTACAO_VIEW',
            );
          }
          if(payload.papeis.includes('AGENTE_MONITORAMENTO_FINANCEIRO')) {
            permissions.push(
              'PERMISSION_PRESTACAO_CONTAS_VIEW',
              'PERMISSION_MONITORAMENTO_FINANCEIRO_VIEW',
              'PERMISSION_MANIFESTACAO_VIEW',
            );
          }
          break;
        case 'FINALIZADO':
          var listaPapelHabilitado = ['AGENTE_PRESTACAO_CONTA', 'AGENTE_MONITORAMENTO_FINANCEIRO', 'COMISSAO_PRESTACAO_CONTA', 'AGENTE_MONITORAMENTO_PROGRAMATICO', 'COORDENADOR_INSTITUCIONAL', 'ADMINISTRADOR_SISTEMA', 'COORDENADOR_SISTEMA'];
          if(payload.papeis.filter(value => listaPapelHabilitado.includes(value))) {
            permissions.push(
              'PERMISSION_PRESTACAO_CONTAS_VIEW',
              'PERMISSION_MONITORAMENTO_FINANCEIRO_VIEW',
              'PERMISSION_MANIFESTACAO_VIEW',
              'PERMISSION_PARECER_VIEW',
            );
          }
          break;
        default:
      }
      return permissions.includes(payload.permission);
    },
  }
}
